const toB64 = (str) => window.btoa(unescape(encodeURIComponent(str)));

const fromB64 = (str) => decodeURIComponent(escape(window.atob(str)));

class BookingInfo {
    constructor() {
        this.data = {
            bookingId: null,
            mail: null,
        };
    }

    load(token) {
        this.data = JSON.parse(fromB64(token));
    }

    get bookingId() {
        return this.data.bookingId;
    }

    set bookingId(value) {
        this.data.bookingId = value;
    }

    get mail() {
        return this.data.mail;
    }

    set mail(value) {
        this.data.mail = value;
    }

    get destinationCity() {
        return this.data.destinationCity;
    }

    set destinationCity(value) {
        this.data.destinationCity = value;
    }

    get token() {
        return toB64(JSON.stringify(this.data));
    }
}

module.exports = new BookingInfo();
